import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, RefreshCw, LogOut, ArrowUpRight, MessageCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/Button';
import { UnlockInfoModal, DISCORD_URL } from '../components/UnlockInfoModal';

export default function AccessRequired() {
  const { user, refresh, logout } = useAuth();
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="grain relative grid min-h-screen place-items-center bg-ink-base px-6 text-white">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md rounded-3xl border border-white/10 bg-ink-card p-8 text-center shadow-inner_glow"
        data-testid="access-required"
      >
        <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-emerald/10 text-emerald">
          <Lock size={28} />
        </div>
        <h1 className="mt-6 font-heading text-2xl font-bold tracking-tight">Looks like you don't have access</h1>
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          Hi {user?.name?.split(' ')[0] || 'there'} — you're signed in, but we couldn't find an active
          Stock Method subscription on your account. It may have expired or not started yet. Upgrade below to
          unlock the full platform.
        </p>

        <div className="mt-8 space-y-3">
          <Button pill size="lg" variant="emerald" className="w-full" onClick={() => setShowInfo(true)} data-testid="access-upgrade-button">
            Upgrade here <ArrowUpRight size={16} />
          </Button>
          <Button pill size="md" variant="outline" className="w-full" onClick={refresh} data-testid="access-refresh-button">
            <RefreshCw size={16} /> I've upgraded — refresh
          </Button>
          <button
            onClick={logout}
            data-testid="access-logout-button"
            className="mx-auto flex items-center gap-2 pt-2 text-sm text-zinc-500 hover:text-red-400"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>

        <div className="mt-8 border-t border-white/5 pt-6">
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="access-discord-link"
            className="flex w-full items-center justify-center gap-2 rounded-full border border-emerald/40 bg-emerald/10 py-3 text-sm font-bold text-emerald transition-colors hover:bg-emerald hover:text-black"
          >
            <MessageCircle size={16} /> Join the free discord
          </a>
        </div>
      </motion.div>

      <UnlockInfoModal open={showInfo} onClose={() => setShowInfo(false)} />
    </div>
  );
}
